import React from 'react'
import { Image, Grid, Header, Button, Responsive } from 'semantic-ui-react'
import { Link } from 'react-router'
import './ArticleSection.scss'
import PropTypes from 'prop-types'
import { TwitterFollowButton, TwitterTimelineEmbed } from 'react-twitter-embed'

const articleSection = (props) => {
  let image = (
    <Grid.Column mobile={16} tablet={8} computer={7}>
      {!props.hasTwitter ? <Image src={props.image} className='articleImage' />
      : (
        <React.Fragment>
          <TwitterFollowButton
            screenName={'BraveProjectEU'}
          />
          <TwitterTimelineEmbed
            sourceType='profile'
            noHeader
            screenName='BraveProjectEU'
            options={{ width: 600 }}
            autoHeight
          />
        </React.Fragment>
      )}
    </Grid.Column>
  )

  let body = (
    <Grid.Column mobile={16} tablet={8} computer={7} className='articleColumn'>
      <div className='articleSection'>
        <div>
          <Header as='h2' style={{ marginBottom: 15 }}>
            {props.title}
            <Header.Subheader>{props.subtitle}</Header.Subheader>
          </Header>
          <div style={{ backgroundColor: 'white', borderRadius: 10 }}>{props.children}</div>
        </div>
        {!props.hideLearnMore && <Button
            className='articleButton'
            as={Link}
            to={props.link}>LEARN MORE
        </Button>}
      </div>
    </Grid.Column>
  )

  return (
    <div>
      <Responsive maxWidth={768}>
        <Grid style={{ display: 'flex', justifyContent: 'center' }} inverted columns={2}>
          {[image, body]}
        </Grid>
      </Responsive>
      <Responsive minWidth={768}>
        <Grid style={{ display: 'flex', justifyContent: 'center' }} inverted columns={2}>
          {props.reverse ? [body, image] : [image, body]}
        </Grid>
      </Responsive>
    </div>
  )
}

articleSection.propTypes = {
  reverse: PropTypes.bool,
  link: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  children: PropTypes.any,
  hasTwitter: PropTypes.bool,
  hideLearnMore: PropTypes.bool
}
export default articleSection



// WEBPACK FOOTER //
// ./src/components/HomeComponent/ArticleSection/ArticleSection.js